import vehicleController from "../../../controllers/vehicleController/controller";
import { EventBus } from '@/eventBus';

export default {
    name: 'SimpleTable',
    data() {
        return {
            company: '',
            vehicleList: [],
            currentPage: 1,
            pageSize: 10,
            totalPages: 0,
            totalVehicles: 0, // Total items dari backend
            searchQuery: '',
            vehicle: {
                name: '',
                height: '',
                image_url: '',
                length: '',
                max_Weight: '',
                volume: '',
                width: '',
                created_by: '',  
                avg_speed: '',
                transport_moda: '',
                is_active: ''               
            },
            selectedVehicle: {
                id: '',
                name: '',
                height: '',
                image_url: '',
                length: '',
                max_Weight: '',
                volume: '',
                width: '',
                created_by: '',
                updated_by: '',
                avg_speed: '',
                transport_moda: '',
                is_active: ''
            }
        };
    },
    computed: {
        filteredVehicles() {
            return this.vehicleList.filter(vehicle => vehicle.name.toLowerCase().includes(this.searchQuery.toLowerCase()));
        },
         pages() {
            return Math.ceil(this.totalVehicles / this.pageSize);
        },
        displayedPages() {
            const range = 1; // Jarak halaman dari currentPage (kiri dan kanan)
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
      
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
              if (start === 1) {
                end = Math.min(3, this.pages);
              } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
              }
            }
      
            const pages = [];
            for (let i = start; i <= end; i++) {
              pages.push(i);
            }
            return pages;
          },
        showStartEllipsis() {
        return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
        return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },
      
    },
    methods: {
        showModal(type, id) {
            const selectedVehicle = this.vehicleList.find(vehicle => vehicle.id === id);
            if (selectedVehicle) {
                this.selectedVehicle = selectedVehicle;
                
                const modal = document.getElementById(type === 'edit' ? 'editVehicle' : 'detailVehicle');
                
                modal.style.display = 'block';
                requestAnimationFrame(() => {
                modal.classList.add('show');
                });
                
                document.body.classList.add('modal-open');
                
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                document.body.appendChild(backdrop);
                
                requestAnimationFrame(() => {
                backdrop.classList.add('show');
                });
            }
        },        
        closeModal() {
            const modalIds = ['tambahVehicle', 'editVehicle', 'detailVehicle'];
            modalIds.forEach(id => {
              const modal = document.getElementById(id);
              if (modal && modal.classList.contains('show')) {
                modal.classList.remove('show');
                setTimeout(() => {
                  modal.style.display = 'none';
                }, 300);
              }
            });
          
            // Hapus backdrop
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => {
              backdrop.classList.remove('show');
              setTimeout(() => {
                if (backdrop.parentNode) {
                  backdrop.parentNode.removeChild(backdrop);
                }
              }, 300);
            });
          
            // Hapus kelas atau atribut yang mengunci scroll pada body
            const body = document.body;
            body.classList.remove('modal-open');
            body.style.overflow = ''; // Menghapus properti overflow jika ada
            this.fetchMenus();
        },  
        resetForm() {
            this.vehicle = {
                name: '',
                height: '',
                image_url: '',
                length: '',
                max_Weight: '',
                volume: '',
                width: '',
                created_by: '',
                avg_speed: '',
                transport_moda: '',
                is_active: ''
            };
        },
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.fetchVehicles();
            }
        },
        async fetchVehicles() {
            try {
                const company = this.company;
                console.log(company);
                //TERANG
                // if (company === '1') {
                //     this.$router.replace({ path: '/' });
                //     console.log('DISINI');
                //     return;
                // }
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await vehicleController.getAllVehicles(query, this.currentPage, this.pageSize);
                this.vehicleList = response.vehicle;
                this.totalAllVehicles();
            } catch (error) {
                console.error('Error fetching services:', error);
                throw error;
            }
        },
        async totalAllVehicles() {
            try {
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await vehicleController.totalAllVehicles(query);
                this.totalVehicles = response.count_vehicle[0].count;
            } catch (error) {
                console.error('Error fetching vehicles:', error);
            }
        },
        onCompanyChange(newCompany) {
            this.company = newCompany;
        }
    },
    mounted() {
        this.fetchVehicles();
        this.company = localStorage.getItem('company');
        EventBus.$on("companyChanged", this.onCompanyChange);
    },
    watch: {
        searchQuery: {
            handler: 'fetchVehicles',
            immediate: true, 
        },
        company: {
            handler: 'fetchAreas'
        }
    },
    beforeDestroy() {
        // bersihkan listener
        EventBus.$off("companyChanged", this.onCompanyChange);
    },
}